import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { BaseService } from '../services/base.service';
import { UIUtil } from '../utils/ui.util';
import { session_keys } from '..';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
// import { AuthService } from './auth/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  getToken() {
    if (UIUtil.getPrivateData(session_keys.private_key).email) {
      return UIUtil.getPrivateData(session_keys.private_key).token;
    } else {
      return '';
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headersConfig = {
      // Accept: 'application/json'
    };

    const token = UIUtil.getPrivateData(session_keys.private_key).token;

    if (token) {
      headersConfig['Authorization'] = `Token ${token}`;
    }

    const request = req.clone({ setHeaders: headersConfig });
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (error.status === 401) {
          localStorage.clear();
          this.router.navigate(['./login']);
        }
        let errMsg ;
        // Client Side Error
        if (error.error instanceof ErrorEvent) {
          errMsg = `Error: ${error.error.message}`;
        } else {
          // Server Side Error
          errMsg = {Error_Code:error.status,Message:error.error.errors};
        }
        return throwError(errMsg);
      })
    );
  }
}
